/* ==========================================================================
   STR8 COUNTER v1.0

   Counts a number up when it scrolls into view. Used by the stat bars on the
   formula hub and every ingredient page.

   Opt in from markup:

     <span class="..." data-str8-count="3000" data-str8-count-suffix="mg"
           data-str8-count-decimals="0">0</span>

   Wrap them in any element carrying data-str8-count-root and the whole group
   fires together the first time that group is seen.

   Honours prefers-reduced-motion by writing the final value immediately, so
   the number is always correct and never stuck at zero.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__str8CounterLoaded) return;
  window.__str8CounterLoaded = true;

  var DURATION = 1400;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function format(value, decimals) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  /* The figure and its unit are separate nodes so the unit can carry its
     own face and casing. Built once, then only the number node is
     rewritten each frame. */
  function parts(el) {
    if (el.__str8Parts) return el.__str8Parts;

    var prefix = el.dataset.str8CountPrefix || '';
    var suffix = el.dataset.str8CountSuffix || '';
    el.textContent = '';

    if (prefix) {
      var pre = document.createElement('span');
      pre.className = 'str8-count-unit';
      pre.textContent = prefix;
      el.appendChild(pre);
    }

    var num = document.createTextNode('0');
    el.appendChild(num);

    if (suffix) {
      var suf = document.createElement('span');
      suf.className = 'str8-count-unit';
      suf.textContent = suffix;
      el.appendChild(suf);
    }

    el.__str8Parts = { num: num };
    return el.__str8Parts;
  }

  function write(el, value) {
    var decimals = parseInt(el.dataset.str8CountDecimals, 10);
    if (isNaN(decimals)) decimals = 0;
    parts(el).num.nodeValue = format(value, decimals);
  }

  function settle(el) {
    write(el, parseFloat(el.dataset.str8Count));
  }

  function run(els) {
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (p >= 1) {
          settle(el);
          continue;
        }
        write(el, eased * parseFloat(el.dataset.str8Count));
      }
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function initRoot(root) {
    if (root.dataset.str8CountBound === 'true') return;
    root.dataset.str8CountBound = 'true';

    var els = root.querySelectorAll('[data-str8-count]');
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) settle(els[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        run(els);
      },
      { threshold: 0.3 }
    );
    observer.observe(root);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-str8-count-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
